// npm packages
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import React, { useEffect, useState } from 'react';

// cookies
import { setCookie } from 'cookies-next';

// utils
import { cn } from '@/utils/cn';

// components
import { useDispatch, useSelector } from 'react-redux';
import { setLang } from '@/redux/reducers/global-settings-reducer';
import { DEFAULT_LOCALE_COOKIE_NAME } from '@/constants';
import Icon from '../Icon';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

function LanguageDropdown({
  option,
  isHamBurgerMenu = false,
  menuButtonClassNames = '',
  arrowColor = '#fff',
  flagWidth = '28',
  flagHeight = '22',
  arrowWidth = '24',
  arrowHeight = '24',
  isMyProfile = false,
}) {
  const dispatch = useDispatch();
  const { lang: selectedValue } = useSelector((state) => state.globalSettings);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [selectedLangIcon, setSelectedLangIcon] = useState(
    '/images/flag-usa.png',
  );

  const handleSelect = (value) => {
    dispatch(setLang(value));
    setCookie(DEFAULT_LOCALE_COOKIE_NAME, value, {
      maxAge:
        (process.env.NEXT_PUBLIC_LOCALE_COOKIE_DAYS || 365) * 24 * 60 * 60,
    });
  };

  useEffect(() => {
    if (selectedValue === 'bn') {
      setSelectedLangIcon('/images/flag-bd.png');
    } else {
      setSelectedLangIcon('/icons/language.svg');
    }
  }, [selectedValue, selectedLangIcon]);

  return (
    <div className="text-right z-[198]">
      <Menu>
        <MenuButton
          className={cn(
            'inline-flex items-center gap-[4px] py-1.5 pl-1 pr-0 text-sm/6 font-semibold text-white focus:outline-none',
            menuButtonClassNames,
          )}
          onClick={() => setIsOpenMenu((preValue) => !preValue)}
        >
          <ImageComponentV2
            src={selectedLangIcon}
            width={flagWidth}
            height={flagHeight}
            alt={selectedValue}
            loading="lazy"
            className="size-[24px] object-cover"
          />
          <Text
            type="paragraph"
            className={cn(
              'text-base text-white uppercase font-bold hover:underline hover:font-black',
              { '!text-coarse-wool': isHamBurgerMenu },
              { '!text-coarse-wool': isMyProfile },
            )}
          >
            {selectedValue}
          </Text>
          <Icon
            type="angle-down"
            color={arrowColor}
            className={cn(`transition duration-200`, {
              'rotate-180': isOpenMenu,
            })}
            width={arrowWidth}
            height={arrowHeight}
          />
        </MenuButton>
        <MenuItems
          transition
          anchor="bottom end"
          className={cn(
            'w-[137px] z-[5011] origin-top-right rounded-8 bg-white text-sm/6 text-gunmetal shadow-language-toggle transition duration-100 ease-out focus:outline-none',
            {
              '!left-16': isHamBurgerMenu,
            },
          )}
        >
          {option?.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                handleSelect(item.name);
                setIsOpenMenu(!isOpenMenu);
              }}
            >
              <button
                type="button"
                className="group flex w-full items-center gap-[16px] rounded-lg py-8 px-16"
              >
                <Text
                  type="paragraph"
                  className={cn(
                    'text-base text-coarse-wool uppercase font-semibold flex items-center',
                    {
                      '!font-bold !text-richcarmine':
                        selectedValue === item.name,
                    },
                  )}
                >
                  <ImageComponentV2
                    src={item.icon}
                    width={28}
                    height={22}
                    alt={item.name}
                    loading="lazy"
                    className="w-[28px] h-[22px] object-cover"
                  />
                  <span className="inline-block ml-10 mr-16">{item.name}</span>
                  <span className="min-w-[24px] min-h-[24px]">
                    {selectedValue === item.name && (
                      <Icon type="checkmark-rounded-bg" />
                    )}
                  </span>
                </Text>
              </button>
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    </div>
  );
}

export default LanguageDropdown;
